import React from 'react';
import {Outlet, useParams} from 'react-router-dom';
import {ALLOWED_COUNTRY_SLUGS, findGeoByCountryCity} from '../data/geoRoutes';
import NotFound from '../pages/NotFound';

const GeoCityGate: React.FC = () => {
    const {country, city} = useParams<{country: string; city: string}>();
    const countrySlug = country?.toLowerCase();

    if (!countrySlug || !ALLOWED_COUNTRY_SLUGS.includes(countrySlug)) {
        return <NotFound/>;
    }

    const geo = findGeoByCountryCity(country, city);
    if (!geo) {
        return <NotFound/>;
    }

    return <Outlet context={geo}/>;
};

export default GeoCityGate;
